import { log } from "@dxos/log";
//#region src/extensions/otel/span-fanout.ts
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/observability/src/extensions/otel/span-fanout.ts";
/**
* Lets a consumer observe ended spans without owning a tracer provider: the SDK takes its span
* processors at construction and offers no way to add one afterwards (`addSpanProcessor` was
* removed in 2.x).
*/
var processors = /* @__PURE__ */ new Set();
/** Attaches a processor to the realm's tracer provider. Returns a function that detaches it. */
var addSpanProcessor = (processor) => {
	processors.add(processor);
	return () => {
		processors.delete(processor);
	};
};
/**
* Passed to the provider at construction; delegates to whatever has attached by the time a span
* ends. A processor that throws is logged and skipped — `onEnd` runs inside `Span.end()`, on the
* fiber that created the span, so an escaping error would fail unrelated work.
*/
var FanoutSpanProcessor = class {
	onStart(span, parentContext) {
		for (const processor of processors) try {
			processor.onStart(span, parentContext);
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 36,
				S: this
			});
		}
	}
	onEnd(span) {
		for (const processor of processors) try {
			processor.onEnd(span);
		} catch (err) {
			log.catch(err, void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 46,
				S: this
			});
		}
	}
	async forceFlush() {
		await Promise.allSettled([...processors].map((processor) => processor.forceFlush()));
	}
	async shutdown() {
		await Promise.allSettled([...processors].map((processor) => processor.shutdown()));
	}
};
//#endregion
export { addSpanProcessor as n, FanoutSpanProcessor as t };

//# sourceMappingURL=chunk-span-fanout.mjs.map